import { provider } from "@grassrootly/api/providers";
import { IPlayer } from "../../entities";

export type AuthenticatePayload = {
  email: string;
  password: string;
};

export const Authenticate = async (params: AuthenticatePayload): Promise<IPlayer> =>
  provider.Request<AuthenticatePayload, IPlayer>("/auth/login", params);
